import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/paypage/topDate.svg'
import _imports_1 from '@/assets/paypage/topKefu.svg'
import _imports_2 from '@/assets/paypage/topPercen.svg'
import _imports_3 from '@/assets/paypage/topSafe.svg'
import _imports_4 from '@/assets/paypage/paypal.svg'
import _imports_5 from '@/assets/paypage/cart.svg'
import _imports_6 from './img/message-gou.svg'
import _imports_7 from './img/pickGou.svg'
import _imports_8 from '@/assets/paypage/features1.svg'
import _imports_9 from '@/assets/paypage/right.svg'
import _imports_10 from '@/assets/paypage/features2.svg'
import _imports_11 from '@/assets/paypage/features3.svg'
import _imports_12 from './img/image1.svg'
import _imports_13 from './img/image2.svg'
import _imports_14 from './img/image3.svg'
import _imports_15 from './img/image4.svg'
import _imports_16 from './img/image6.svg'
import _imports_17 from './img/image7.svg'
import _imports_18 from './img/image8.svg'
import _imports_19 from './img/image9.svg'
import _imports_20 from './img/image5.svg'


const _withScopeId = n => (_pushScopeId("data-v-01e32f5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "whole" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "wholeBox" }
const _hoisted_5 = { class: "wholeItem" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "wholeItem" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "wholeItem" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "wholeItem" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "selectBox" }
const _hoisted_14 = { class: "middle" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "elRow" }
const _hoisted_17 = { class: "plan" }
const _hoisted_18 = { class: "price" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delPrice" }, "$85.99", -1))
const _hoisted_20 = { class: "current" }
const _hoisted_21 = { class: "priceBottom" }
const _hoisted_22 = { class: "button" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_26 = { class: "message" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "first" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_30 = { class: "dec" }
const _hoisted_31 = { class: "first" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_33 = { class: "dec" }
const _hoisted_34 = { class: "first" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_36 = { class: "dec" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "first" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_40 = { class: "dec" }
const _hoisted_41 = { class: "first" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_43 = { class: "dec" }
const _hoisted_44 = { class: "first" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_46 = { class: "dec" }
const _hoisted_47 = { class: "first" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_49 = { class: "dec" }
const _hoisted_50 = { class: "save" }
const _hoisted_51 = { class: "saveText" }
const _hoisted_52 = { class: "plan" }
const _hoisted_53 = { class: "price recommend" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delPrice" }, "$55.99", -1))
const _hoisted_55 = { class: "current" }
const _hoisted_56 = { class: "priceBottom" }
const _hoisted_57 = { class: "button" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2 3H3.75L4.5 6M4.5 6L7 16H20L22.5 6H4.5Z",
    stroke: "#2DB249",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 21C7.82843 21 8.5 20.3284 8.5 19.5C8.5 18.6716 7.82843 18 7 18C6.17157 18 5.5 18.6716 5.5 19.5C5.5 20.3284 6.17157 21 7 21Z",
    fill: "#2DB249"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 21C20.8284 21 21.5 20.3284 21.5 19.5C21.5 18.6716 20.8284 18 20 18C19.1716 18 18.5 18.6716 18.5 19.5C18.5 20.3284 19.1716 21 20 21Z",
    fill: "#2DB249"
  })
], -1))
const _hoisted_61 = { class: "message" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "first" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "img"
}, null, -1))
const _hoisted_65 = { class: "dec" }
const _hoisted_66 = { class: "first" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "img"
}, null, -1))
const _hoisted_68 = { class: "dec" }
const _hoisted_69 = { class: "first" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "img"
}, null, -1))
const _hoisted_71 = { class: "dec" }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "first" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "img"
}, null, -1))
const _hoisted_75 = { class: "dec" }
const _hoisted_76 = { class: "first" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "img"
}, null, -1))
const _hoisted_78 = { class: "dec" }
const _hoisted_79 = { class: "first" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "img"
}, null, -1))
const _hoisted_81 = { class: "dec" }
const _hoisted_82 = { class: "first" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "img"
}, null, -1))
const _hoisted_84 = { class: "dec" }
const _hoisted_85 = { class: "plan" }
const _hoisted_86 = { class: "price" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delPrice" }, "$145.99", -1))
const _hoisted_88 = { class: "current" }
const _hoisted_89 = { class: "priceBottom" }
const _hoisted_90 = { class: "button" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_94 = { class: "message" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "first" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_98 = { class: "dec" }
const _hoisted_99 = { class: "first" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_101 = { class: "dec" }
const _hoisted_102 = { class: "first" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_104 = { class: "dec" }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { class: "first" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_108 = { class: "dec" }
const _hoisted_109 = { class: "first" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_111 = { class: "dec" }
const _hoisted_112 = { class: "first" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_114 = { class: "dec" }
const _hoisted_115 = { class: "first" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_117 = { class: "dec" }
const _hoisted_118 = { class: "middleTitle" }
const _hoisted_119 = { class: "middleEquity" }
const _hoisted_120 = { class: "elCol" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "",
  class: "itemImg"
}, null, -1))
const _hoisted_122 = { class: "itemP" }
const _hoisted_123 = { class: "itemli" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_125 = { class: "itemli" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_127 = { class: "itemli" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_129 = { class: "itemli" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_131 = { class: "itemli" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_133 = { class: "itemli" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_135 = { class: "itemli" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_137 = { class: "itemli" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_139 = { class: "itemli" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_141 = { class: "itemli" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_143 = { class: "itemli" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_145 = { class: "itemli" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_147 = { class: "itemBox ul2" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: "",
  class: "itemImg"
}, null, -1))
const _hoisted_149 = { class: "itemP" }
const _hoisted_150 = { class: "itemli" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: "",
  class: "itemImg"
}, null, -1))
const _hoisted_153 = { class: "itemP" }
const _hoisted_154 = { class: "itemli" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_156 = { class: "itemli" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_158 = { class: "itemli" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_160 = { class: "itemli" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_162 = { class: "itemli" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_164 = { class: "itemli" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_166 = { class: "itemli" }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_168 = { class: "itemli" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_170 = { class: "itemli" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_172 = { class: "itemli" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_174 = { class: "itemli" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_176 = { class: "itemli" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_178 = { class: "bottom" }
const _hoisted_179 = { class: "row" }
const _hoisted_180 = /*#__PURE__*/_createStaticVNode("<div data-v-01e32f5a><img src=\"" + _imports_12 + "\" data-v-01e32f5a><img src=\"" + _imports_13 + "\" data-v-01e32f5a><img src=\"" + _imports_14 + "\" data-v-01e32f5a><img src=\"" + _imports_15 + "\" data-v-01e32f5a><img src=\"" + _imports_16 + "\" data-v-01e32f5a><img src=\"" + _imports_17 + "\" data-v-01e32f5a><img src=\"" + _imports_18 + "\" data-v-01e32f5a><img src=\"" + _imports_19 + "\" data-v-01e32f5a><img src=\"" + _imports_20 + "\" data-v-01e32f5a></div>", 1)

import { onMounted, ref, computed, reactive } from "vue";
// import { getCartUrl } from "@/api/login";
import { useStore } from "vuex";
import { gaEvent, coinsForm } from "@/utils/format";
import { useI18n } from "vue-i18n";
import { getMoins } from "@/api/cart";
import devices from 'current-device';

interface CoinItem {
  price: number;
  cycle_type: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'payPage',
  setup(__props) {

const store = useStore();
let pick = ref(0);
let temp = ref();
const allCoins = ref<CoinItem[]>([]);//1月 3月 1年的价格
const { t } = useI18n();
const choseMeal = (menu: number) => {
  pick.value = menu;
  console.log("pick.value", pick.value);
};
const conins = ref([] as number[])
const lang = computed(() => store.state.currentLang);
const originUrl = ref(1)

const feature1 = reactive([
  t('famikeep210.WhatsApp Chat'),
  t('famikeep210.Location Reminder'),
  t('famikeep210.App Activity'),
  t('famikeep210.Live Location'),
  t('famikeep210.App Blocker'),
  t('famikeep210.Safe Search'),
  t('famikeep210.Monitor Social Apps'),
  t('famikeep210.Web Filter'),
  t('famikeep200.Geofence'),
  t('famikeep210.Browser History'),
  t('famikeep210.Location History'),
  t('famikeep210.Content Detection'),
])
const feature2 = [
  'kakao',
  'WhatsApp',
  'TikTok',
  'Youtube',
  'Tinder',
  'Instagram',
  'Telegram',
  'Snapchat',
  'Kik',
  'Facebook',
  'WeChat',
  'LINE'
]
const feature3 = reactive([
  t('famikeep210.All SMS'),
  t('famikeep210.Call History'),
  t('famikeep210.Photos'),
  t('famikeep210.Call Recording'),
  t('famikeep210.Video'),
  t('famikeep210.Contacts'),
  t('famikeep210.Calendar'),
  t('famikeep210.Messages'),
  t('famikeep210.Documents'),
  t('famikeep210.Call Logs'),
  t('famikeep210.Record Screen'),
  t('famikeep210.Chat History'),
])
const payMessageAnd = ref([
  t("payPage.update"),
  t("payPage.collect"),
  t("payPage.interaction"),
  t("payPage.hide")
])
const payMessageIos = ref([
  t('famikeep210.Location History1'),
  t("payPage.interaction"),
  t('famikeep210.Auto Renewal'),
])
const selectedDeviceType = ref(0) //默认选中安卓

const choosePlan = ref(false);
const deviceType = computed(() => {
  return store.state.deviceType
})

const goToBuyFun = async (data: number) => {
  if (data == 1) {
    gaEvent("Click_BuyButton_LicenseChoose", {
      event_category: "Buy",
      event_label: selectedDeviceType.value ? 'iOS_Month' : "Android_Month",
    });
    store.commit("setPayMenu", "Month");
    temp.value = "monthly";

    // 发送网络请求
    if (originUrl.value && !selectedDeviceType.value) {
      console.log(111);

      window.open("https://order.parentalguard.com/api/v1/cart?g=103696&l=1&currency=USD")
    } else if (originUrl.value && selectedDeviceType.value) {
      console.log(222);

      window.open("https://order.parentalguard.com/api/v1/cart?g=103701&l=1&currency=USD")
    } else {
      console.log(3333);

      window.open("https://order.famikeep.com/api/v1/cart?g=102214&l=1&currency=USD")
    }

  } else if (data == 2) {
    gaEvent("Click_BuyButton_LicenseChoose", {
      event_category: "Buy",
      event_label: selectedDeviceType.value ? 'iOS_Quarter' : "Android_Quarter",
    });
    store.commit("setPayMenu", "Quarter");
    temp.value = "quarterly";
    choosePlan.value = true;
    if (originUrl.value && !selectedDeviceType.value) {
      window.open("https://order.parentalguard.com/api/v1/cart?g=103697&l=1&currency=USD")
    } else if (originUrl.value && selectedDeviceType.value) {
      window.open("https://order.parentalguard.com/api/v1/cart?g=103702&l=1&currency=USD")
    } else {
      window.open("https://order.famikeep.com/api/v1/cart?g=102215&l=1&currency=USD")
    }

  } else {
    gaEvent("Click_BuyButton_LicenseChoose", {
      event_category: "Buy",
      event_label: selectedDeviceType.value ? 'iOS_Year' : "Android_Year",
    });
    store.commit("setPayMenu", "Year");
    temp.value = "yearly";
    if (originUrl.value && !selectedDeviceType.value) {
      window.open("https://order.parentalguard.com/api/v1/cart?g=103698&l=1&currency=USD")
    } else if (originUrl.value && selectedDeviceType.value) {
      window.open("https://order.parentalguard.com/api/v1/cart?g=103703&l=1&currency=USD")
    } else {
      window.open("https://order.famikeep.com/api/v1/cart?g=102216&l=1&currency=USD")
    }

  }
  store.commit('setSelectMeal', selectedDeviceType.value)
};


const goTopayBuyFun = async (data: number) => {
  if (data == 1) {
    gaEvent("Click_Paypal", {
      event_category: "Buy",
      event_label: selectedDeviceType.value ? 'iOS_Month' : "Android_Month",
    });
    store.commit("setPayMenu", "Month");
    temp.value = "monthly";

    // 发送网络请求
    if (originUrl.value && !selectedDeviceType.value) {
      console.log(111);

      window.open("https://apis.parentalguard.com/v1/cart?s=364&g[103696]=1&currency=&lang=en&cart=3")
    } else if (originUrl.value && selectedDeviceType.value) {
      console.log(222);

      window.open("https://apis.parentalguard.com/v1/cart?s=364&g[103701]=1&currency=&lang=en&cart=3")
    } else {
      console.log(3333);

      window.open("https://order.famikeep.com/api/v1/cart?g=102214&l=1&currency=USD")
    }

  } else if (data == 2) {
    gaEvent("Click_Paypal", {
      event_category: "Buy",
      event_label: selectedDeviceType.value ? 'iOS_Quarter' : "Android_Quarter",
    });
    store.commit("setPayMenu", "Quarter");
    temp.value = "quarterly";
    choosePlan.value = true;
    if (originUrl.value && !selectedDeviceType.value) {
      window.open("https://apis.parentalguard.com/v1/cart?s=364&g[103697]=1&currency=&lang=en&cart=3")
    } else if (originUrl.value && selectedDeviceType.value) {
      window.open("https://apis.parentalguard.com/v1/cart?s=364&g[103702]=1&currency=&lang=en&cart=3")
    } else {
      window.open("https://order.famikeep.com/api/v1/cart?g=102215&l=1&currency=USD")
    }

  } else {
    gaEvent("Click_Paypal", {
      event_category: "Buy",
      event_label: selectedDeviceType.value ? 'iOS_Year' : "Android_Year",
    });
    store.commit("setPayMenu", "Year");
    temp.value = "yearly";
    if (originUrl.value && !selectedDeviceType.value) {
      window.open("https://apis.parentalguard.com/v1/cart?s=364&g[103698]=1&currency=&lang=en&cart=3")
    } else if (originUrl.value && selectedDeviceType.value) {
      window.open("https://apis.parentalguard.com/v1/cart?s=364&g[103703]=1&currency=&lang=en&cart=3")
    } else {
      window.open("https://order.famikeep.com/api/v1/cart?g=102216&l=1&currency=USD")
    }

  }
  store.commit('setSelectMeal', selectedDeviceType.value)
};

const goDemo = (meal: any) => {
  console.log('meal', meal);
  if (meal == 1) {
    gaEvent("See_Demo", {
      event_category: "Buy",
      event_label: selectedDeviceType.value ? 'iOS_Month' : "Android_Month",
    });
  } else if (meal == 2) {
    gaEvent("See_Demo", {
      event_category: "Buy",
      event_label: selectedDeviceType.value ? 'iOS_Quarter' : "Android_Quarter",
    });
  } else {
    gaEvent("See_Demo", {
      event_category: "Buy",
      event_label: selectedDeviceType.value ? 'iOS_Year' : "Android_Year",
    });
  }
}

//切换货币价格
const changeMoin = async (index: number) => {
  let params: any

  if (originUrl.value) {
    if (index) {
      params = {
        pid: 7723,
      }
    } else {
      params = {
        pid: 7722,
      }
    }
  } else {
    params = {
      pid: 5881,
    }

  }

  // // 发送网络请求，获取购物车地址
  getMoins(params, { baseURLtype: 'VUE_APP_CART_BASE_URL' })
    .then((result: any) => {
      conins.value = []
      allCoins.value = []
      console.log("result.data[0]:", result.data[0].price);

      result.data.forEach((element: any) => {
        let obj = {
          price: element.price,
          cycle_type: element.cycle_type
        }
        allCoins.value.push(obj)
      });
      // 在新窗口打开付费页面
      // console.log('url:', result.data.data.url)

      allCoins.value.sort((a: any, b: any) => {
        return a.cycle_type - b.cycle_type;
      });
      allCoins.value.forEach((item: any) => {
        conins.value.push(item.price)
      })

      console.log("allCoins.value.price:", allCoins.value[0].price);
      console.log("allCoins.value.price:", conins.value);
    }).catch((e) => {

    })


  // window.open(result.data.data.url)
}
//切换选中设备
const changeSelectedDeviced = (data: number) => {
  selectedDeviceType.value = data
  console.log("selectedDeviceType.value:", selectedDeviceType.value);
  changeMoin(data)

}

onMounted(() => {
  if (window.location.origin.includes('famikeep')) {
    originUrl.value = 0
  }
  if (deviceType.value) {
    changeSelectedDeviced(1)
  } else {
    changeSelectedDeviced(0)

  }

  try {
    // 在购买页刷新的时候，onMounted会比建立ws连接更快，所以不能在建立连接的时候send，所以加一个延迟
    setTimeout(() => {
      console.log("store.state.wsObj:", store.state.wsObj);

      store.state.wsObj.send("permission");
    }, 5000);
  } catch (err) {
    console.log(err);
  }
  setTimeout(() => {
    const timing = window.performance.timing;
    const loadTime = Math.floor(timing.loadEventEnd - timing.navigationStart);
    console.log(`Page load time: ${loadTime} milliseconds`);
    gaEvent("Buy_LoadingTime", {
      event_category: "LoadingTime",
      event_label: `${loadTime}ms`,
    });
  }, 2000)


});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["payPage", lang.value == 'ar' ? 'reverse1' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('famikeep210.ParentalGuard - Parental Control App Pricing & Plans')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.30-Day Money Back Guarantee')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Professional Customer Support')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.All Prices Exclusive of VAT')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.100% Secure')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: _normalizeClass(["box pointer", selectedDeviceType.value ? '' : 'active']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSelectedDeviced(0)))
          }, "Android ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["box pointer", selectedDeviceType.value ? 'active' : '']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeSelectedDeviced(1)))
          }, "IOS", 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "single order1",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (choseMeal(2))),
            style: _normalizeStyle({ 'margin-right': lang.value == 'ar' ? '0px' : '2rem' })
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("payPage.three")), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", _hoisted_20, "$" + _toDisplayString(_unref(coinsForm)(conins.value[1], 2)) + "/" + _toDisplayString(_ctx.$t('famikeep210.Day')), 1),
              _createElementVNode("p", _hoisted_21, "$" + _toDisplayString(conins.value[1]) + "/ " + _toDisplayString(_ctx.$t('famikeep210.Quarter')), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", {
                class: "paypelButton",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (goTopayBuyFun(2)))
              }, _hoisted_24),
              _createElementVNode("a", {
                class: "goToBuy",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (goToBuyFun(2)))
              }, [
                _hoisted_25,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("payPage.toBuy")), 1)
              ]),
              _createElementVNode("a", {
                href: "https://demo.parentalguard.com/",
                class: "seeDemoA",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (goDemo(2)))
              }, _toDisplayString(_ctx.$t("famikeep210.See Demo")), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              (selectedDeviceType.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("famikeep210.Location History1")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("payPage.interaction")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("famikeep210.Auto Renewal")), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("payPage.update")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("payPage.collect")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("payPage.interaction")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("payPage.hide")), 1)
                    ])
                  ]))
            ])
          ], 4),
          _createElementVNode("div", {
            class: "single active order2",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (choseMeal(1)))
          }, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("payPage.bigSave")), 1)
            ]),
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("payPage.one")), 1),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("span", _hoisted_55, "$" + _toDisplayString(_unref(coinsForm)(conins.value[2], 1)) + "/" + _toDisplayString(_ctx.$t('famikeep210.Day')), 1),
              _createElementVNode("p", _hoisted_56, "$" + _toDisplayString(conins.value[2]) + "/ " + _toDisplayString(_ctx.$t('famikeep210.Month')), 1)
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", {
                class: "paypelButton",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (goTopayBuyFun(1))),
                style: {"min-width":"272px"}
              }, _hoisted_59),
              _createElementVNode("a", {
                class: "goToBuy",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (goToBuyFun(1))),
                style: {"min-width":"272px"}
              }, [
                _hoisted_60,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("payPage.toBuy")), 1)
              ]),
              _createElementVNode("a", {
                href: "https://demo.parentalguard.com/",
                class: "seeDemoA",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (goDemo(1)))
              }, _toDisplayString(_ctx.$t("famikeep210.See Demo")), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              (selectedDeviceType.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("famikeep210.Location History1")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t("payPage.interaction")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _hoisted_70,
                      _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t("famikeep210.Auto Renewal")), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$t("payPage.update")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t("payPage.collect")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t("payPage.interaction")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$t("payPage.hide")), 1)
                    ])
                  ]))
            ])
          ]),
          _createElementVNode("div", {
            class: "single order3",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (choseMeal(3))),
            style: _normalizeStyle({ 'margin-right': lang.value == 'ar' ? '2rem' : '0px' })
          }, [
            _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.$t("payPage.year")), 1),
            _createElementVNode("div", _hoisted_86, [
              _hoisted_87,
              _createElementVNode("span", _hoisted_88, "$" + _toDisplayString(_unref(coinsForm)(conins.value[0], 3)) + "/" + _toDisplayString(_ctx.$t('famikeep210.Day')), 1),
              _createElementVNode("p", _hoisted_89, "$" + _toDisplayString(conins.value[0]) + "/ " + _toDisplayString(_ctx.$t('famikeep210.Year')), 1)
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", {
                class: "paypelButton",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (goTopayBuyFun(3)))
              }, _hoisted_92),
              _createElementVNode("a", {
                class: "goToBuy",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (goToBuyFun(3)))
              }, [
                _hoisted_93,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("payPage.toBuy")), 1)
              ]),
              _createElementVNode("a", {
                href: "https://demo.parentalguard.com/",
                class: "seeDemoA",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (goDemo(3)))
              }, _toDisplayString(_ctx.$t("famikeep210.See Demo")), 1)
            ]),
            _createElementVNode("div", _hoisted_94, [
              (selectedDeviceType.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _hoisted_97,
                      _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t("famikeep210.Location History1")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _hoisted_100,
                      _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.$t("payPage.interaction")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _hoisted_103,
                      _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.$t("famikeep210.Auto Renewal")), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_105, [
                    _createElementVNode("div", _hoisted_106, [
                      _hoisted_107,
                      _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.$t("payPage.update")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _hoisted_110,
                      _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.$t("payPage.collect")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_112, [
                      _hoisted_113,
                      _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.$t("payPage.interaction")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_115, [
                      _hoisted_116,
                      _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.$t("payPage.hide")), 1)
                    ])
                  ]))
            ])
          ], 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.$t('famikeep210.More Features to Keep Your Kids Safe Online')), 1),
      _createElementVNode("div", _hoisted_119, [
        _createElementVNode("div", _hoisted_120, [
          _createElementVNode("div", {
            class: "itemBox ul1",
            style: _normalizeStyle({ 'margin-right': lang.value == 'ar' ? '0' : '2rem' })
          }, [
            _hoisted_121,
            _createElementVNode("p", _hoisted_122, _toDisplayString(_ctx.$t('famikeep210.Features')), 1),
            _createElementVNode("div", {
              class: _normalizeClass(lang.value == 'ar' ? 'itemulAr' : 'itemul')
            }, [
              _createElementVNode("div", _hoisted_123, [
                _hoisted_124,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.WhatsApp Chat')), 1)
              ]),
              _createElementVNode("div", _hoisted_125, [
                _hoisted_126,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Location Reminder')), 1)
              ]),
              _createElementVNode("div", _hoisted_127, [
                _hoisted_128,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.App Activity')), 1)
              ]),
              _createElementVNode("div", _hoisted_129, [
                _hoisted_130,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Live Location')), 1)
              ]),
              _createElementVNode("div", _hoisted_131, [
                _hoisted_132,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.App Blocker')), 1)
              ]),
              _createElementVNode("div", _hoisted_133, [
                _hoisted_134,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Safe Search')), 1)
              ]),
              _createElementVNode("div", _hoisted_135, [
                _hoisted_136,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Monitor Social Apps')), 1)
              ]),
              _createElementVNode("div", _hoisted_137, [
                _hoisted_138,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Web Filter')), 1)
              ]),
              _createElementVNode("div", _hoisted_139, [
                _hoisted_140,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Geofence')), 1)
              ]),
              _createElementVNode("div", _hoisted_141, [
                _hoisted_142,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Browser History')), 1)
              ]),
              _createElementVNode("div", _hoisted_143, [
                _hoisted_144,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Location History')), 1)
              ]),
              _createElementVNode("div", _hoisted_145, [
                _hoisted_146,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Content Detection')), 1)
              ])
            ], 2)
          ], 4),
          _createElementVNode("div", _hoisted_147, [
            _hoisted_148,
            _createElementVNode("p", _hoisted_149, _toDisplayString(_ctx.$t('famikeep210.Monitor App')), 1),
            _createElementVNode("div", {
              class: _normalizeClass(lang.value == 'ar' ? 'itemulAr' : 'itemul')
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(feature2, (item) => {
                return _createElementVNode("div", _hoisted_150, [
                  _hoisted_151,
                  _createElementVNode("span", null, _toDisplayString(item), 1)
                ])
              }), 64))
            ], 2)
          ]),
          _createElementVNode("div", {
            class: "itemBox ul3",
            style: _normalizeStyle({ 'margin-right': lang.value == 'ar' ? '2rem' : '0' })
          }, [
            _hoisted_152,
            _createElementVNode("p", _hoisted_153, _toDisplayString(_ctx.$t('famikeep210.Type of Data')), 1),
            _createElementVNode("div", {
              class: _normalizeClass(lang.value == 'ar' ? 'itemulAr' : 'itemul')
            }, [
              _createElementVNode("div", _hoisted_154, [
                _hoisted_155,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.All SMS')), 1)
              ]),
              _createElementVNode("div", _hoisted_156, [
                _hoisted_157,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Call History')), 1)
              ]),
              _createElementVNode("div", _hoisted_158, [
                _hoisted_159,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Photos')), 1)
              ]),
              _createElementVNode("div", _hoisted_160, [
                _hoisted_161,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Call Recording')), 1)
              ]),
              _createElementVNode("div", _hoisted_162, [
                _hoisted_163,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Video')), 1)
              ]),
              _createElementVNode("div", _hoisted_164, [
                _hoisted_165,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Contacts')), 1)
              ]),
              _createElementVNode("div", _hoisted_166, [
                _hoisted_167,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Calendar')), 1)
              ]),
              _createElementVNode("div", _hoisted_168, [
                _hoisted_169,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Messages')), 1)
              ]),
              _createElementVNode("div", _hoisted_170, [
                _hoisted_171,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Documents')), 1)
              ]),
              _createElementVNode("div", _hoisted_172, [
                _hoisted_173,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Call Logs')), 1)
              ]),
              _createElementVNode("div", _hoisted_174, [
                _hoisted_175,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Record Screen')), 1)
              ]),
              _createElementVNode("div", _hoisted_176, [
                _hoisted_177,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Chat History')), 1)
              ])
            ], 2)
          ], 4)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_178, [
      _createElementVNode("div", _hoisted_179, [
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('famikeep210.We Accept')) + ":", 1),
        _hoisted_180
      ])
    ])
  ], 2))
}
}

})